<template>
    <div>
        <div class="mb-8 w-full md:mb-4">
            <h3
                v-if="isSmallScreen"
                class="mb-4 font-display-3"
            >
                {{ flashcardSet.title }}
            </h3>

            <div class="flex flex-wrap items-center text-sm">
                <div class="mr-2 flex text-slate-600">
                    <i class="icon icon-flashcards"> </i>
                    {{ flashcardSet.amount_cards }}
                    {{ $t('flashcards:flashcardShowHeader.card_count', flashcardSet.amount_cards) }}
                </div>
                <div
                    v-if="!hasRewards"
                    class="mr-2 flex text-slate-600"
                >
                    <i class="icon icon-people mr-1"> </i>
                    {{ flashcardSet.amount_rewards }}
                    {{ $t('flashcards:flashcardShowHeader.user_studied') }}
                </div>
                <Btn
                    v-if="hasDescription && !isSmallScreen"
                    v-tooltip="{
                        content: flashcardSet.description,
                        placement: 'bottom',
                        showTriggers: ['hover', 'click'],
                    }"
                    variant="text"
                    right-icon="chevron-down"
                    :label="$t('flashcards:flashcardShowHeader.label_description')"
                    size="sm"
                    class="!font-normal !text-sm mr-2"
                >
                </Btn>
                <UserAvatar
                    :name="flashcardSet.owner ? flashcardSet.owner.first_name : 'Anonymous User'"
                    :user-id="flashcardSet.owner ? flashcardSet.owner.userid : 0"
                    :is-anonymous="isAnonymousSet"
                    :link="isAnonymousSet ? null : flashcardSet.owner.link"
                    :karma-points="isAnonymousSet || isDeletedUser ? null : flashcardSet.owner.karma_points"
                    show-details
                    :animated-avatar="isAnonymousSet ? null : flashcardSet.owner.gamify_avatar_url"
                    :picture="isAnonymousSet ? null : flashcardSet.owner.picture"
                    :show-admin-badge="flashcardSet.owner.is_admin"
                    :timestamp="flashcardSet.time"
                    date-in-line
                    alternate-user-name-color
                    class="exclude-verified exclude-auth mt-1 w-full md:mt-0 md:w-auto"
                    size="xs"
                >
                </UserAvatar>
            </div>
        </div>

        <Btn
            v-if="hasCourse"
            :label="flashcardSet.course.university.name"
            :href="flashcardSet.course.university.link"
            :size="BtnSize.SM"
            class="flashcard-tag"
            color="primary"
            :variant="BtnVariant.OUTLINED"
        />
        <Btn
            v-if="hasCourse"
            :label="flashcardSet.course.name"
            :href="flashcardSet.course.link"
            :size="BtnSize.SM"
            class="flashcard-tag"
            color="primary"
            :variant="BtnVariant.OUTLINED"
        />
        <!-- native modifier has been removed, please confirm whether the function has been affected  -->
        <Btn
            v-if="hasSemester"
            :size="BtnSize.SM"
            class="flashcard-tag"
            color="primary"
            :variant="BtnVariant.OUTLINED"
            :label="FlashcardSemesterLabel"
        />
        <!-- native modifier has been removed, please confirm whether the function has been affected  -->
        <Btn
            v-if="hasProfessor"
            :size="BtnSize.SM"
            class="flashcard-tag"
            color="primary"
            :variant="BtnVariant.OUTLINED"
            :label="flashcardSet.professor.name"
        />
        <!-- native modifier has been removed, please confirm whether the function has been affected  -->
        <Btn
            v-for="(tag, index) in flashcardSet.tags"
            :size="BtnSize.SM"
            :key="index"
            :variant="BtnVariant.OUTLINED"
            :label="tag.name"
            color="primary"
            class="flashcard-tag cursor-default"
        />

        <template v-if="hasDescription && isSmallScreen">
            <h4 class="mb-3">
                {{ $t('flashcards:flashcardShowHeader.label_description') }}
            </h4>
            <p class="text-slate-600">
                {{ flashcardSet.description }}
            </p>
        </template>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { BtnVariant, BtnSize } from '@components/Btn';
import { displayFlashcardSemester } from '@/utils/semesterUtils';

export default {
    data() {
        return {
            BtnVariant,
            BtnSize,
        };
    },
    props: {
        flashcardSet: {
            type: Object,
            required: true,
        },
        user: {
            type: Object,
            required: false,
        },
    },
    computed: {
        ...mapGetters('ui', ['screenSize']),
        hasCourse() {
            return !!this.flashcardSet.course;
        },
        hasDescription() {
            return !!this.flashcardSet.description;
        },
        hasProfessor() {
            return !!this.flashcardSet.professor;
        },
        hasRewards() {
            return this.flashcardSet.amount_rewards === 0;
        },
        hasSemester() {
            return !!this.flashcardSet.semester;
        },
        isAnonymousSet() {
            return this.flashcardSet.is_anonymous === 1;
        },
        isSmallScreen() {
            return this.screenSize === 'small';
        },
        isDeletedUser() {
            return !this.flashcardSet.owner.userid;
        },
        FlashcardSemesterLabel() {
            return displayFlashcardSemester(this.flashcardSet.semester);
        },
    },
    methods: {
        displayFlashcardSemester,
    },
    i18nOptions: {
        namespaces: ['flashcards'],
    },
};
</script>

<style lang="scss" scoped>
.flashcard-tag {
    @apply mb-2 mr-2 whitespace-nowrap leading-relaxed font-normal;
}

@screen md {
    .flashcard-tag {
        @apply mb-5 text-base;
    }
}
</style>
